import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { Pill } from '../../shared/components/Pill';
import { hashSemanticColor } from '../../shared/components/semanticColor';
import type { SearchEntityResult } from '../../core/types/data-models';

/** Read-only detail popup for an entity clicked from the search results. */
export function SearchEntityDialog({
  entity,
  onClose,
}: {
  entity: SearchEntityResult | null;
  onClose: () => void;
}) {
  const navigate = useNavigate();

  return (
    <Dialog open={!!entity} onClose={onClose} maxWidth="xs" fullWidth>
      {entity && (
        <>
          <DialogTitle sx={{ pr: 6 }}>
            {entity.entityName}
            <IconButton onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Stack spacing={2}>
              <Pill color={hashSemanticColor(entity.entityType)}>{entity.entityType}</Pill>
              {entity.entityDescription && (
                <Typography variant="body2" color="text.secondary">
                  {entity.entityDescription}
                </Typography>
              )}
              <Stack spacing={0.25}>
                <Typography variant="caption" color="text.secondary">Related to</Typography>
                <Typography variant="body2">
                  {entity.documentName} › {entity.documentSectionTitle}
                </Typography>
              </Stack>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  onClose();
                  navigate(`/documents/${entity.documentId}`);
                }}
                sx={{ alignSelf: 'flex-start' }}
              >
                Go to document
              </Button>
            </Stack>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}
